import './LevelNImageCard.css';

import { fullImagePath, generateClassName } from '../../b2b-common/helpers';
import useLevelNImagePath from '../hooks/useLevelNImagePath';
import React, { useEffect, useState } from 'react';
import StatusTrendFactory from '../../b2b-plans/components/status-trend/StatusTrendFactory';
import ProgressFactory from '../../b2b-plans/components/progress/ProgressFactory';
import { isEqual } from 'lodash';

const LevelNImageCard = ({ frameworkSuite, frameworkId, levelN,
    progress = 0, 
    showProgress = false,
    status = '',
    showStatus = false,
    trend = '',
    showTrend = false,
    onClick = null,
    selectedLevelNs = [],
    allowsSelection = false,
    className = null }) => {
    const imagePath = useLevelNImagePath(frameworkSuite, frameworkId, levelN.levelN_ItemId);
    const [currentSelectedLevelNs, setCurrentSelectedLevelNs] = useState(selectedLevelNs);
    const [isSelected, setIsSelected] = useState(false);

    useEffect(() => {
        // console.log('LevelNImageCard - Selected levelNs:', selectedLevelNs);
        if (!isEqual(selectedLevelNs, currentSelectedLevelNs)) {
            setCurrentSelectedLevelNs(selectedLevelNs);
        }
        if (selectedLevelNs.some(selectedLevelN_Id => selectedLevelN_Id === levelN.levelN_ItemId)) {
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [selectedLevelNs]);

    const handleClick = () => {
        setIsSelected(!isSelected);
        if (onClick) {
            onClick(levelN);
        }
    }

    return (
        <div className={`${generateClassName('levelN-card-image','',className)} ${allowsSelection ? 'allows-selection' : ''} ${isSelected ? 'selected-levelN':''}`} onClick={handleClick}>
            <img src={fullImagePath(imagePath)} alt='' />
            <StatusTrendFactory approach='COMBINED' status={status} trend={trend}
                showStatus={showStatus} showTrend={showTrend}
                className='levelN-card-image-status-and-trend' />
            <ProgressFactory progressApproach='SIMPLE' targetProgress={progress ? progress : 0}
                showCalendarProgress={false} showTargetProgress={showProgress}
                className='levelN-card-image-progress'
            />
        </div>
    );
}

export default LevelNImageCard;